<template>
    <v-card>
        <v-card-title>
            <h2>Cards</h2>
        </v-card-title>
        <v-card-text>
            <ul v-if="cards.length > 0">
                <li
                    v-for="(card, index) in cards"
                    :key="index"
                >
                    <router-link :to="`/card/edit/${card.id}`">
                        {{ card.name }}
                    </router-link>
                </li>
            </ul>
            <p v-else>
                <span>
                    This section contains no cards.
                </span>
            </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn to="/card/create">
                <v-icon
                    left
                    small
                >
                    fas fa-plus-circle
                </v-icon>
                Add Card
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState('pageEditor', ['cards', 'name'])
    }
};
</script>
